// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../../../node_modules/decco/src/Decco.bs.js";
import * as Js_dict from "../../../../../../../node_modules/rescript/lib/es6/js_dict.js";

function t_encode(v) {
  return Js_dict.fromArray([
              [
                "msisdn",
                Decco.stringToJson(v.msisdn)
              ],
              [
                "whitelist_types",
                Decco.arrayToJson(Decco.stringToJson, v.whitelistTypes)
              ],
              [
                "comment",
                Decco.stringToJson(v.comment)
              ]
            ]);
}

export {
  t_encode ,
  
}
/* No side effect */
